<template>
    <v-container grid-list-md align-center text-xs-center>
        <v-layout wrap flex>
            <v-flex xs12 v-if="sessoes && sessoes.length > 0">
                <div class="error pa-2 text-xs-center">
                    <h3 style="color: white;">
                    {{ strings[idioma].foram_encontrados_logins_simultaneos }}:
                    </h3>
                    <ol>
                    <li
                        v-for="s of sessoes"
                        :key="s.id"
                        style="color: white;">
                        <b
                        >({{
                        moment(s.created_at).format(
                            strings[idioma].formato_datas_com_hora
                        )
                        }}(GMT)) -
                        <a
                            :href="'https://www.geodatatool.com/en/?IP=' + s.ip"
                            target="_blank"
                        >{{ s.ip }}</a
                        >
                        - {{ s.os }} - {{ s.browser }} - {{ s.dispositivo }}</b
                        >
                    </li>
                    </ol>
                    <div>
                    <v-btn @click="fuieuLogin()">
                        {{ strings[idioma].fui_eu_estou_de_acordo }}
                    </v-btn>
                    <v-btn @click="naofuieuLogin()">
                        {{ strings[idioma].nao_fui_eu_estou_de_acordo }}
                    </v-btn>
                    </div>
                    <strong>{{
                    strings[idioma].o_compartilhamento_senhas_proibido
                    }}</strong>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import { mapState } from 'vuex'
    export default {
        data () {
            return {
                sessoes: []
            }
        },
        computed: {
            ...mapState('app', [
            'dietasAtivas',
            'data',
            'acesso_premium',
            'strings',
            'idioma',
            'user',
            'ingredientes',
            'optionsNumber',
            'alimentos_selecionados',
            'categorias_alimentos',
            'alimentos_usuario',
            'alert',
            'dietas',
            'predicoes',
            'tabelas',
            'empresa',
            'tabHome',
            'exibeTesteGratis'
            ]),
        },
        mounted () {
            this.getSessoes()
        },
        methods: {
            fuieuLogin () {
                this.sessoes = []
                localStorage.setItem('sessoes', JSON.stringify(this.sessoes))
            },
            mudarSenha () {
                this.loadingAlimentos = true
                this.axios
                    .post('/auth/esqueciSenha', { email: this.user.email })
                    .then((_) => {
                        this.loadingAlimentos = false
                        let msg = this.strings[this.idioma].enviado.format(this.user.email)
                        let title = this.strings[this.idioma].mudanca_senha
                        this.$store.commit('openOKModal', { title, msg })
                    })
                    .catch((_) => {
                        this.loadingAlimentos = false
                        let msg = this.strings[this.idioma].usuario_nao_encontrado
                        let time = 6000
                        this.$store.commit('openErrorAlert', { msg, time })
                    })
            },
            naofuieuLogin () {
                this.sessoes = []
                localStorage.setItem('sessoes', JSON.stringify(this.sessoes))
                this.mudarSenha()
            },
            getSessoes () {
                this.axios.post('auth/meuIP', {}).then((r) => {
                    let meuIP = r.data.data
                    this.sessoes = JSON.parse(localStorage.getItem('sessoes'))
                    if (this.sessoes && this.sessoes !== null) {
                        this.sessoes = this.sessoes.filter((s) => s.ip !== meuIP)
                    }
                })
            }
        }
    }
</script>